<template>
  <div class="infoBox">
    <div
      style="position:absolute;transform:translate(-47%, -286%);z-index:10"
      :style="{
        left: param.x + 'px',
        top: param.y + 'px'
      }"
    >
      <div class="warn">
        <p>{{ param.name }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    param: Object
  }
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/styl/varibles.styl'

.infoBox
  z-index 10

.warn
  padding 5px 8px
  border-radius 15px 0 15px 0
  background $titleColor
  z-index 1

  :before
    content ''
    transform translate(-35%, 0)
    position absolute
    bottom -9px
    left 50%
    opacity 1
    border-top solid 10px #ffd400
    border-right solid 10px transparent
    border-left solid 10px transparent
</style>
